export const CONTACT_SELLER_SECTION_ID = 'contact';

export const POST_AD_CONTAINER_ID = 'post-ad-container';

export const HEADER_ID = 'HEADER_ID';

export const FOOTER_ID = 'FOOTER_ID';


export const SHOULD_SHOW_OPEN_LAYER_MAPS = true;




// WEBPACK FOOTER //
// ./src/constants.ts